<p-tree [value]="treeData" [(selection)]="selectedNode" (onNodeExpand)="handleNodeExpand($event)"
  (onNodeCollapse)="handleNodeCollapse($event)" (selectionChange)="handleSelectionChange()"
  class="w-full p-tree-one" [emptyMessage]="emptyMessage">

  <ng-template let-node pTemplate="default">

    <!-- Renderizar nodos "Agregar" (add-programa, add-bien-servicio, add-indicador) -->
    <ng-container *ngIf="isAddNode(node)">
      <div class="w-100 flex align-items-center gap-3">

        <!-- Nivel 0: Programa -->
        <ng-container *ngIf="getAddNodeLevel(node) === 0 && addNodeLevel0Template">
          <ng-container *ngTemplateOutlet="addNodeLevel0Template; context: { $implicit: node }"></ng-container>
        </ng-container>
        <ng-container *ngIf="getAddNodeLevel(node) === 0 && !addNodeLevel0Template">
          <ng-content select="[addNodeLevel0]"></ng-content>
        </ng-container>

        <!-- Nivel 1: Bien o Servicio -->
        <ng-container *ngIf="getAddNodeLevel(node) === 1 && addNodeLevel1Template">
          <ng-container *ngTemplateOutlet="addNodeLevel1Template; context: { $implicit: node }"></ng-container>
        </ng-container>
        <ng-container *ngIf="getAddNodeLevel(node) === 1 && !addNodeLevel1Template">
          <ng-content select="[addNodeLevel1]"></ng-content>
        </ng-container>

        <!-- Nivel 2: Indicador -->
        <ng-container *ngIf="getAddNodeLevel(node) === 2 && addNodeLevel2Template">
          <ng-container *ngTemplateOutlet="addNodeLevel2Template; context: { $implicit: node }"></ng-container>
        </ng-container>
        <ng-container *ngIf="getAddNodeLevel(node) === 2 && !addNodeLevel2Template">
          <ng-content select="[addNodeLevel2]"></ng-content>
        </ng-container>
      </div>
    </ng-container>

    <!-- Renderizar nodos normales -->
    <ng-container *ngIf="!isAddNode(node)">
      <div class="flex justify-content-between align-items-center gap-3">

        <!-- Contenido principal del nodo -->
        <div class="w-full flex justify-content-between align-items-center gap-2">
          <ng-container *ngIf="nodeContentTemplate">
            <ng-container *ngTemplateOutlet="nodeContentTemplate; context: { $implicit: node }"></ng-container>
          </ng-container>
          <ng-container *ngIf="!nodeContentTemplate">
            <ng-content select="[nodeContent]"></ng-content>
          </ng-container>
        </div>

        <!-- Acciones/botones del nodo -->
        <div class="flex gap-5 align-items-center justify-content-end" [ngStyle]="{
          'min-width': node.level === 2 ? '319px' : '150px'
        }">
          <ng-container *ngIf="nodeActionsTemplate">
            <ng-container *ngTemplateOutlet="nodeActionsTemplate; context: { $implicit: node }"></ng-container>
          </ng-container>
          <ng-container *ngIf="!nodeActionsTemplate">
            <ng-content select="[nodeActions]"></ng-content>
          </ng-container>
        </div>
      </div>
    </ng-container>

  </ng-template>

</p-tree>